import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux'
import store from './store'


import {
  HashRouter
} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fontsource/metropolis";
import "@fontsource/montserrat";


import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
  startEvent: 'load',
  offset: -50,
  duration: 300,
  easing: 'ease-in-sine'
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Suspense fallback={<div>Loading ... </div>}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
